import FDictionary from '../__select';
import Form from './Form';

export default class FDictionaryExcursion extends FDictionary {
  dictionary = 'excursion';

  permissionAdd = [115];

  constructor(props) {
    super(props);
    if (props.country) {
      this.country = props.country;
    }
    if (props.region) {
      this.country = props.region;
    }
    if (props.city) {
      this.city = props.city;
    }
  }

  get country() {
    return this.refs.data.country;
  }

  set country(value) {
    if (!value) {
      return;
    }
    this.refs.data.country = value;
    this.refs.set('country', value);
    if (this.region) {
      this.region.country = this.country;
    }
    if (this.city) {
      this.city.country = this.country;
    }
  }

  get region() {
    return this.refs.data.region;
  }

  set region(value) {
    if (!value) {
      return;
    }
    this.refs.data.region = value;
    this.refs.set('region', value);
    if (this.country) {
      this.region.country = this.country;
    }
    if (this.city) {
      this.city.region = this.region;
    }
  }

  get city() {
    return this.refs.data.city;
  }

  set city(value) {
    if (!value) {
      return;
    }
    this.refs.data.city = value;
    this.refs.set('city', value);
    if (this.country) {
      this.city.country = this.country;
    }
    if (this.region) {
      this.city.region = this.region;
    }
  }

  getOptions(model = this.refs.data) {
    const { city } = model;
    if (!city) {
      return Promise.resolve(this.setOptions([]));
    }
    return super.getOptions({ city });
  }

  addForm() {
    const item = new Form();
    item.init()
      .then(() => {
        if (this.country) {
          item.country.set(this.country);
          item.country.disabled = true;
        }
        if (this.region) {
          item.region.set(this.region);
          item.region.disabled = true;
        }
        if (this.city) {
          item.region.disabled = true;
          item.city.set(this.city);
          item.city.disabled = true;
        }
      });
    return item;
  }
}
